import React from "react";

const GeneratorRelayPanel = () => {
  return (
    <div className="bg-white text-gray-800 p-6 rounded-xl shadow-xl border border-emerald-200 w-full">
      <h3 className="text-2xl font-bold text-emerald-700 mb-4">
        Generator Relay Panel
      </h3>

      <ul className="list-disc list-inside space-y-2 mb-4">
        <li>Review of generator construction & operation</li>
        <li>Review of grounding and connection</li>
        <li>Study of IEEE / IEC standards for generator protection</li>
        <li>
          Explore generator elements:
          <ul className="list-decimal list-inside ml-5 space-y-1">
            <li>Internal fault</li>
            <li>Abnormal operating condition</li>
            <li>Generator zone</li>
            <li>Out of zone</li>
            <li>External fault</li>
          </ul>
        </li>
        <li>Study of single line diagram</li>
        <li>Preparation of generation logic (AND & OR)</li>
      </ul>
    </div>
  );
};

export default GeneratorRelayPanel;
